import React from "react";
import { MutateFunction } from "react-query";
import { api } from "../api";
import { ChannelProps } from "../typing/channels";

export const getAllAppUsers = async () => {
    return await api.get(`auth/users/list`);
};
export const getAllRegisteredUsers = async () => {
    return await api.get(`auth/users/registered/list`);
};
export const getAllIncompleteUsers = async () => {
    return await api.get(`auth/users/unregistered/list`);
};
export const getAllRemovedUsers = async () => {
    return await api.get(`auth/users/removed/list`);
};
export const getAllBlockedUsers = async () => {
    return await api.get(`auth/users/blocked/list`);
};

// export const createChannel: MutateFunction<
//   ChannelProps,
//   Partial<ChannelProps>,
//   ChannelProps
// > = async (payload: any) => {
//   return api.post("channel/new", undefined, payload);
// };

// export const updateChannel: MutateFunction<
//   ChannelProps,
//   Partial<ChannelProps>,
//   { payload: ChannelProps; id: number }
// > = async ({ payload, id }) => {
//   console.log("id : ", id);
//   return api.patch(`channel/update/${id}`, undefined, payload);
// };

export const deleteUser: MutateFunction<string, any, string> = (id) => {
    return api.delete(`auth/user/${id}`);
};

export const blockUser: MutateFunction<string, any, string> = (id) => {
    return api.patch(`auth/user/block/${id}`);
};

export const unblockUser: MutateFunction<string, any, string> = (id) => {
    return api.patch(`auth/user/unblock/${id}`);
};
